import script from "./MProfileCompany.vue?vue&type=script&setup=true&lang=js"
export * from "./MProfileCompany.vue?vue&type=script&setup=true&lang=js"

import "./MProfileCompany.vue?vue&type=style&index=0&id=50118212&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50118212"]])

export default __exports__